import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApplicationsContract } from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { terraApiWrapper } from '../../utils/terraApiWrapper';
import { DYNAMIC_APPLICATION_SCAN_AUTOMATION_QUERY_KEY } from './useDynamicApplicationScanAutomation';

const stopDynamicApplicationScan = async ({
  applicationId,
}: {
  applicationId: string;
}) => {
  const result = await terraApiWrapper<
    typeof ApplicationsContract.stopDynamicApplicationScan
  >({
    endpointFn: () =>
      applicationsClient.stopDynamicApplicationScan({
        params: { id: applicationId },
      }),
  });

  if (result === undefined) {
    throw new Error('Failed to stop dynamic application scan');
  }

  return result;
};

export const useStopDynamicApplicationScan = ({
  applicationId,
}: {
  applicationId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => stopDynamicApplicationScan({ applicationId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [
          DYNAMIC_APPLICATION_SCAN_AUTOMATION_QUERY_KEY,
          applicationId,
        ],
      });
    },
  });
};
